import React from "react";
import PropTypes from "prop-types";
import EditableText from "./EditableText";
import { COPYRIGHT_STYLE } from "./textStyles";

function PageCopyright({ pageId }) {
  return (
    <>
      <div className="full-width-line" />
      <EditableText
        id={`${pageId}.copyright`}
        defaultContent={`Copyright © ${new Date().getFullYear()} 香槟厄巴纳生命河教会`}
        defaultStyle={COPYRIGHT_STYLE}
      />
    </>
  );
}

PageCopyright.propTypes = {
  pageId: PropTypes.string.isRequired,
};

export default PageCopyright;
